<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <h1 class="titulo mb-3">CONFIGURAÇÃO DE FLAVORS</h1>
        <v-card>
            <v-card-text>
                <div id="tabs" class="container">
                    <div class="tabs">
                        <a @click="activetab=ID_VISUAL" :class="{ active: activetab === ID_VISUAL }">ID Visual</a>
                        <a @click="activetab=AMBIENTES" :class="{ active: activetab === AMBIENTES }">Ambientes</a>
                    </div>

                    <div v-if="activetab === ID_VISUAL" class="tabcontent">
                        <v-layout class="d-flex justify-end mb-3">
                            <v-btn color="primary" @click="exportarExcel">
                                <v-icon left size="18">
                                    mdi-file-chart
                                </v-icon>
                                SALVAR RELATÓRIO
                            </v-btn>
                        </v-layout>
                        <div style="position:relative;padding-bottom:60px">
                            <DataTableVue :headers='headers' :params="params"
                                          :filter="dtFiltro" url="/painel/flavors" overflow-y-visible
                                          ref="datatable">
                                <template v-slot:header="header">
                                    <th v-for="(header, i) in headers" :key="i" style="height: 5px">
                                        <div v-if="header.value === 'nome_exibicao'" class="tooltip-icon position-relative" style="width: 18px; height: 18px; position: relative; margin-top: -35px; margin-left: 100%">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon size="18" v-on="on" class="mr-1" color="primary">mdi-help-box</v-icon>
                                                </template>
                                                <span>O nome da marca configurada será exibido no sistema de vendas, no menu lateral de forma fixa.</span>
                                            </v-tooltip>
                                        </div>
                                        <div v-if="header.value === 'permite_todos_produtos'" class="tooltip-icon position-relative" style="width: 18px; height: 18px; position: relative; margin-top: -35px; margin-left: 100%">
                                            <v-icon size="18" color="primary" @mouseleave="opacity_produtos = 0"
                                                    @mouseenter="opacity_produtos = 1">
                                                mdi-help-box
                                            </v-icon>
                                            <div class="tooltip-descricao-produtos v-card transition" :style="{ opacity: opacity_produtos ? opacity_produtos : 0, zIndex: opacity_produtos ? '2' : '-2' }">
                                                <span style="color: #222222">Será exibido os produtos, planos e grupos de todas as empresas durante o fluxo de venda.</span>
                                            </div>
                                        </div>
                                        <div v-if="header.value === 'empresas_permitidas'" class="tooltip-icon position-relative" style="width: 18px; height: 18px; position: relative; margin-top: -35px; margin-left: 100%">
                                            <v-icon size="18" color="primary" @mouseleave="opacity_empresas = 0"
                                                    @mouseenter="opacity_empresas = 1">
                                                mdi-help-box
                                            </v-icon>
                                            <div class="tooltip-descricao-empresas v-card transition" :style="{ opacity: opacity_empresas ? opacity_empresas : 0, zIndex: opacity_empresas ? '2' : '-2' }">
                                                <span style="color: #222222">Configuração considerando apenas em acesso de usuários backoffice que contenham o privilégio Venda BackOffice.</span>
                                            </div>
                                        </div>
                                    </th>
                                </template>
                                <template v-slot:items="{item}">
                                    <td>{{ item.nm_flavor }}</td>
                                    <td>{{ item.nome_amigavel }}</td>
                                    <td>{{ item.url }}</td>
                                    <td @mouseover="podeAlterar(true)" @blur="podeAlterar(false)">
                                        <v-switch
                                                class="center"
                                                v-model="item.permite_todos_produtos"
                                                @change="guardarAlteracaoFeitaPermiteTodasEmpresas(item.id, $event)"
                                        ></v-switch>
                                    </td>
                                    <td style="max-width: 300px;" @mouseover="podeAlterar(true)" @blur="podeAlterar(false)">
                                        <Autocomplete multiple :items="getOnlyEmpresasId()" :hide-selected="false"
                                                      :value=" JSON.parse(`[${item.empresas_permitidas}]`)" item-value="value" item-text="text"
                                                      @input="guardarAlteracaoFeitaEmpresasPermitidas(item.id, $event)"
                                                      placeholder="Selecione as empresas permitidas" />
                                    </td>
                                    <td>
                                        <div v-if="!listaEditandoNomeExibicao.includes(item.id)" class="d-flex align-center">
                                            <div class="mr-2">{{ getNomeExibicao(item.id,item.nome_exibicao) }}</div>
                                            <div>
                                                <v-icon v-if="getEditarOuCancelarNomeExibicao(item.id)" @click="ativarEdicaoNomeExibicao(item.id)" style="cursor:pointer">mdi-pencil</v-icon>
                                                <v-icon v-else @click="retirarListaEdicaoNomeExibicao(item.id)" style="cursor:pointer">mdi-close-outline</v-icon>
                                            </div>
                                        </div>
                                        <div v-else class="d-flex justify-space-between align-center">
                                            <v-text-field :rules="[$rules.required]" maxlength="30" v-model="item.nomeTemporario" class="mr-2" />
                                            <div><v-icon color="success" @click="salvarEdicaoNomeExibicao(item,item.nomeTemporario)" style="cursor:pointer">mdi-check-bold</v-icon></div>
                                            <div><v-icon color="advice" @click="cancelarEdicaoNomeExibicao(item.id)" style="cursor:pointer">mdi-close-outline</v-icon></div>
                                        </div>
                                    </td>
                                </template>
                            </DataTableVue>

                            <v-btn color="primary" id="ButtonSalvar" @click="salvarDadosFlavor()">
                                Salvar
                            </v-btn>
                        </div>
                    </div>
                    <div v-else-if="activetab === AMBIENTES" class="tabcontent">
                        <Ambientes @load="recarregarTabela" />
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import DataTableVue from '../../components/DataTable.vue'
  import { mapState } from 'vuex'
  import Ambientes from './Ambientes.vue'
  import * as Qs from 'qs'

  export default {
    name: 'FlavorConfig',
    components: {
      DataTableVue,
      Ambientes
    },
    data: () => ({
      activetab: 'id_visual',
      tipos_usuarios: [],
      permissoes: [],
      filters: {
        id: '',
        nm_flavor: '',
        nome_amigavel: ''
      },
      listaEditandoNomeExibicao: [],
      listaNomesExibicaoEditados: {},
      dadosRespostaPermiteTodasEmpresas: [],
      dadosRespostaEmpresasPermitidas: [],
      podeGuardarAlteracoesDosCampos: false,
      headers: [
        { text: 'Código', value: 'nm_flavor' },
        { text: 'Nome', value: 'nome_amigavel' },
        { text: 'URL Base', value: 'url' },
        { text: 'Todos os produtos', value: 'permite_todos_produtos', icon: 'mdi-help-box', iconIsNedded: true, infoList: ['Será exibido os produtos, planos e grupos de todas as empresas durante o fluxo de venda'], opacity: 0 },
        { text: 'Empresas Permitidas', value: 'empresas_permitidas', icon: 'mdi-help-box', iconIsNedded: true, infoList: ['Configuração considerando apenas em acesso de usuários backoffice que contenham o privilégio Venda BackOffice'], opacity: 0 },
        { text: 'Nome marca exibição', value: 'nome_exibicao' }
      ],
      params: {
        pagination: {
          rowsPerPage: 12,
          page: 1,
          sortBy: 'id',
          descending: false
        },
        data_hora_de: null,
        data_hora_ate: null,
        funcionalidade: null,
        operacao: null
      },
      opacity_produtos: 0,
      opacity_empresas: 0,
      dtFiltro: {}
    }),
    computed: {
      ...mapState([
        'empresas'
      ]),
      ID_VISUAL: () => 'id_visual',
      AMBIENTES: () => 'ambientes'
    },
    mounted () {
      this.recarregarTabela()
    },
    methods: {
      ativarEdicaoNomeExibicao (id_flavor) {
        this.listaEditandoNomeExibicao.push(id_flavor)
      },
      cancelarEdicaoNomeExibicao (id_flavor) {
        const indice = this.listaEditandoNomeExibicao.indexOf(id_flavor)
        this.listaEditandoNomeExibicao.splice(indice, 1)
      },
      getNomeExibicao (id_flavor, nome_atual) {
        if (this.listaNomesExibicaoEditados[id_flavor]) {
          return this.listaNomesExibicaoEditados[id_flavor].nome_exibicao
        } else {
          return nome_atual
        }
      },
      retirarListaEdicaoNomeExibicao (id_flavor) {
        delete this.listaNomesExibicaoEditados[id_flavor]
        this.ativarEdicaoNomeExibicao(id_flavor)
        this.cancelarEdicaoNomeExibicao(id_flavor)
      },
      getEditarOuCancelarNomeExibicao (id_flavor) {
        if (this.listaNomesExibicaoEditados[id_flavor]) {
          return false
        } else {
          return true
        }
      },
      exportarExcel () {
        const headersExport = this.headers
          .filter(h => h.value)
          .map(h => h.value)

        const headersFormatadoExport = this.headers
          .filter(h => h.value)
          .map(h => h.text)

        const encoded_params = Qs.stringify({
          filter: {},
          pagination: { sortBy: 'id', descending: false },
          headers: headersExport,
          headers_formatado: headersFormatadoExport
        }, {
          arrayFormat: 'brackets',
          encode: true
        })

        try {
          window.open(`${this.ws}/id_visual/exportar?${encoded_params}`)
        } catch (error) {
          notification('error', `${error.response?.data?.error || error.message}`)
        }
      },
      salvarEdicaoNomeExibicao (item, nome_novo) {
        if (!nome_novo) {
          notification('warning', 'É necessário informar um nome!')
          return
        }

        this.cancelarEdicaoNomeExibicao(item.id)
        this.listaNomesExibicaoEditados[item.id] = { 'id': item.id, 'nome_exibicao': nome_novo }
      },
      async salvarDadosFlavor () {
        this.$http.put('/painel/flavors/alterar', { dadosTodasEmpresas: this.dadosRespostaPermiteTodasEmpresas, dadosEmpresasPermitidas: this.dadosRespostaEmpresasPermitidas, dadosListaNomes: this.listaNomesExibicaoEditados })
          .then(() => {
            notification('success', 'Sucesso ao salvar os flavors.')
          })
          .catch(() => {
            notification('error', 'Erro ao salvar os flavors')
          }).finally(() => {
            this.dadosRespostaPermiteTodasEmpresas = []
            this.dadosRespostaEmpresasPermitidas = []
            this.listaNomesExibicaoEditados = {}
            this.listaEditandoNomeExibicao = []
            this.recarregarTabela()
          })
      },
      guardarAlteracaoFeitaPermiteTodasEmpresas (id, evento) {
        if (this.podeGuardarAlteracoesDosCampos) {
          this.dadosRespostaPermiteTodasEmpresas.forEach(item => {
            if (item.id === id) {
              this.dadosRespostaPermiteTodasEmpresas.splice(this.dadosRespostaPermiteTodasEmpresas.indexOf(item), 1)
            }
          })
          this.dadosRespostaPermiteTodasEmpresas.push({ 'id': id, 'evento': evento })
        }
      },
      guardarAlteracaoFeitaEmpresasPermitidas (id, evento) {
        if (this.podeGuardarAlteracoesDosCampos) {
          this.dadosRespostaEmpresasPermitidas.forEach(item => {
            if (item.id === id) {
              this.dadosRespostaEmpresasPermitidas.splice(this.dadosRespostaEmpresasPermitidas.indexOf(item), 1)
            }
          })
          this.dadosRespostaEmpresasPermitidas.push({ 'id': id, 'evento': evento })
        }
      },
      podeAlterar (valor) {
        this.podeGuardarAlteracoesDosCampos = valor
      },
      recarregarTabela () {
        this.$refs.datatable.reload()
      },
      getOnlyEmpresasId () {
        try {
          return this.empresas.map(empresa => {
            return {
              text: empresa.ID_Empresa, value: empresa.ID_Empresa
            }
          })
        } catch (e) {
          console.error(e)
          return []
        }
      }
    }
  }
</script>

<style lang='scss' scoped>
#ButtonSalvar {
  position: absolute;
  right: 0px;
  bottom: 0px;
}
.tooltip-descricao-empresas {
    position: absolute;
    left: -150px;
    top: 100%;
    max-width: 200px;
    width: 200px;
    opacity: 0;
    margin-top: 10px;
    padding: 12px;
    background-color: #eee;
    color: #666;
    z-index: 1;
}

.tooltip-descricao-produtos {
    position: absolute;
    margin-top: 10px;
    left: 0;
    top: 100%;
    padding: 12px;
    background-color: #eee;
    color: #666;
    max-width: 200px;
    width: 200px;
    opacity: 0;
    z-index: 2;
}
@import url('../../assets/css/tabs.css');
</style>
